import {
  Label,
  Icon,
  InputType,
  Input,
  convertISOStringToLocalDateString,
  convertDateToISOString,
} from '@gcl/react-core';
import * as React from 'react';
import { useDeepCompareEffectNoCheck } from 'use-deep-compare-effect';
import { DateTimeFilter, IFilterInputBaseProps } from '../searchFilter.models';
import { getFilterValue } from '../searchFilter.services';
import './DateTimeFilterInput.scss';

export interface IDateTimeFilterInputProps extends IFilterInputBaseProps<DateTimeFilter> {}

export const DateTimeFilterInput: React.FunctionComponent<IDateTimeFilterInputProps> = ({
  fieldConfig,
  onChange,
  filter = {},
  disabled = false,
}) => {
  const [localFrom, setLocalFrom] = React.useState<string | undefined>(undefined);
  const [localTo, setLocalTo] = React.useState<string | undefined>(undefined);
  const { fieldName, displayName, disable } = fieldConfig;

  useDeepCompareEffectNoCheck(() => {
    const value = getFilterValue(fieldName, filter);
    const fromString = value && value?.from ? convertISOStringToLocalDateString(value?.from) : undefined;
    const toString = value && value?.to ? convertISOStringToLocalDateString(value?.to) : undefined;

    setLocalFrom(fromString);
    setLocalTo(toString);
  }, [JSON.stringify(filter)]);

  const toDateTime = (newValue: string | number | undefined): string | undefined => {
    if (newValue && typeof newValue === 'string') return convertDateToISOString(new Date(newValue.toString()));
    return undefined;
  };

  return (
    <>
      <Label labelFor={fieldName}>{displayName}</Label>
      <div className="gcl-gems-date-time-filter-container">
        <Input
          className="gcl-gems-date-time-filter-input"
          id={`${fieldName}From`}
          type={InputType.Date}
          disabled={disabled || disable}
          value={localFrom}
          onChange={(newValue) => {
            onChange(fieldName, newValue || localTo ? { from: toDateTime(newValue), to: localTo } : undefined);
          }}
        />
        <span className="gcl-gems-date-time-filter-dash-label">
          <Icon iconName="Dash" size={14} />{' '}
        </span>
        <Input
          className="gcl-gems-date-time-filter-input"
          id={`${fieldName}To`}
          type={InputType.Date}
          disabled={disabled}
          value={localTo}
          onChange={(newValue) => {
            onChange(fieldName, newValue || localFrom ? { from: localFrom, to: toDateTime(newValue) } : undefined);
          }}
        />
      </div>
    </>
  );
};
